//vue
import Vue from 'vue';

//
// global 3rd-parties
//

// bootstrap
import { BootstrapVue } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

// fortawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faFacebook, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faFacebook, faTwitter, faLinkedin);
library.add(faPrint);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// skd plugins, stores, routes, locales
import './plugins';
import store from './app/store';
import { router } from './app/routes';

// vue-i18n
import i18n from './app/services/i18n.service.js';

// skd components
import App from './app/App.vue';
// import Test from './app/components/fieldservice/Test.vue';

//vee-validate
import './app/common/ValidationConfig';

import GlobalMixin from "@/app/common/global-mixin.js";
Vue.mixin(GlobalMixin)

Vue.config.productionTip = false;

// // custom directive to detect user click
// Vue.directive('click-anywhere', {
//     bind: function (el, binding, vnode) {
//       el.clickAnywhere = function (event) {
//         // call method provided in attribute value
//         vnode.context[binding.expression](event);
//       };
//       document.body.addEventListener('click', el.clickAnywhere)
//     },
//     unbind: function (el) {
//       document.body.removeEventListener('click', el.clickAnywhere)
//     },
//   });


// create the vue app
export default new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
